import { DepictCarouselBlock } from "@/types"

type MainVariant = {
    items?: { sku: string }[]
    productSku: string
}

type MatchedCart = {
    checkoutApiSelection?: {
        selection?: {
            items: { sku: string }[]
        }
    }
}

export const transformDepictCarousel = (
    depictCarousel: DepictCarouselBlock,
    data: MainVariant | MatchedCart,
    transformType: "productPage" | "cartPage"
) => {
    const generateKey = () => Math.random().toString(36).substring(2, 15)

    if (transformType === "productPage" && "productSku" in data) {
        depictCarousel.items = [
            {
                depictProductDisplayId: data.items?.[0]?.sku || data.productSku,
                _type: "depictProductContent",
                _key: generateKey()
            }
        ]
    }

    if (transformType === "cartPage" && "checkoutApiSelection" in data) {
        depictCarousel.items =
            data.checkoutApiSelection?.selection?.items.map(item => ({
                depictProductDisplayId: item.sku,
                _type: "depictProductContent",
                _key: generateKey()
            })) || []
    }
}
